import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

const QUERY_KEY = ['SettingsGeneral']

export const useSettingsGeneral = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/settings/general`, {
        method: 'GET',
        headers,
      })
      if (!res.ok) {
        throw new Error("We couldn't load the clinic settings")
      }
      return res.json()
    },
  })

  return { clinic: data, isLoading, isError }
}

export const useUpdateGeneral = () => {
  const queryClient = useQueryClient()

  const { mutateAsync: updateGeneral, ...rest } = useMutation({
    mutationFn: async clinicData => {
      const res = await fetch(`${baseURL}/v2/rest/settings/general`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({ clinic: clinicData }),
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.errors || 'Could not update clinic settings')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: ['Clinic'] })
    },
  })

  return { updateGeneral, ...rest }
}
